import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=e2a360d6&scoped=true&"
import script from "./forgetPassword.vue?vue&type=script&lang=js&"
export * from "./forgetPassword.vue?vue&type=script&lang=js&"
import style1 from "./forgetPassword.vue?vue&type=style&index=1&id=e2a360d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a360d6",
  null
  
)

export default component.exports